import { StreamSource } from "../hooks/streams";

export interface NativeSettings {
    minimumIosBuildNumber: number,
    minimumAndroidBuildNumber: number,
    subscriptionEnabled: boolean,
    favoritesEnabled: boolean,
    maintenance: boolean,
    resultsEnabled: boolean
}

export const DatabaseStateSource = new StreamSource<any>("/server/dbstate");

export const CacheSource = new StreamSource<any>("/server/cache");

export const AdminSqlToolSource = new StreamSource<any>("/admin/tools/sql");

export const ActivitySource = new StreamSource<any>("/all-activity");

export const CaptchaSource = new StreamSource<any>("/captcha");

export const NativeSource = new StreamSource<NativeSettings>("/native");
